import React, { useContext, useState } from "react";
import styled from "styled-components";
import TextArea from "../../components/TextArea";
import { ProfileContext } from "../../reducers/profile";
import { useHistory } from "react-router";
import Section from "../../components/Section";
import { useMutation } from "@apollo/client";
import { SIGN_IN } from "../../graphql_tags";

export default () => {
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [signIn] = useMutation(SIGN_IN);
  const history = useHistory();
  const {
    state: { user_name, user_id },
    dispatch,
  } = useContext(ProfileContext);

  const onSubmit = () => {
    signIn({ variables: { id: user_id, password: pass } })
      .then(async ({ data }) => {
        const {
          signIn: { user_token, is_admin, is_locked },
        } = data;

        localStorage.setItem("token", user_token);

        dispatch({
          type: "ME_AUTH",
          payload: { is_auth: true, is_admin, is_locked },
        });

        history.push(is_admin ? "/results" : "/finalists");
      })
      .catch((error) => {
        setError(error.graphQLErrors[0].message);
        setTimeout(() => setError(""), 1000);
      });
  };

  const onChange = (e) => {
    setPass(e.target.value);
    e.preventDefault();
  };

  const handleBackHome = () => {
    history.push("/");
  };

  return (
    <Form>
      <InputName as="div" onClick={handleBackHome}>
        {user_name}
      </InputName>
      <InputPass
        as="input"
        type="text"
        error={error}
        disabled={error}
        placeholder={error ? error : "Введите пароль"}
        value={error ? "" : pass}
        onChange={onChange}
      />
      {!!pass && <SubmitBtn onClick={onSubmit}>Начать тестирование</SubmitBtn>}
    </Form>
  );
};

const InputName = styled(TextArea)`
  color: #000000;
  display: flex;
  align-items: center;
  font-family: RobotoRegular, sans-serif;
  font-size: 36px;
  height: 72px;
  width: 100%;
  cursor: pointer;
  position: relative;

  :hover {
    ::after {
      display: flex;
      align-items: center;
      content: "Вернуться к выбору ФИО члена Конкурсной комиссии";
      position: absolute;
      max-width: 100%;
      height: 100%;
      left: 0;
      right: 0;
      padding-left: 20px;
      background-color: rgb(32, 117, 188);
      color: #edede9;
    }
  }
`;

const InputPass = styled(InputName)`
  margin-top: 30px;
  ${({ error }) => error && "border-color: #DA5E50;"};

  ::placeholder {
    color: ${({ error }) => (error ? "#DA5E50" : "#777777")};
  }
`;

const Form = styled(Section)`
  margin-top: 70px;
  margin-bottom: 80px;
`;

const SubmitBtn = styled.button`
  width: 404px;
  height: 80px;
  margin-top: 45px;

  background: #339760;
  border: 3px solid #339760;
  box-sizing: border-box;
  border-radius: 10px;

  font-family: RobotoRegular, sans-serif;
  font-size: 36px;
  cursor: pointer;

  color: #ffffff;
`;
